import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const PromoteModalLoading = () => (
  <div data-testid="promote-modal-loading">
    <DialogTitle>
      <Skeleton
        data-testid="promote-modal-loading-title"
        height={28}
        width={'100%'}
      />
    </DialogTitle>
    <DialogContent>
      <Divider />
      <Stack direction="row" spacing={2} py={2}>
        <Skeleton
          data-testid="promote-modal-loading-icon"
          height={24}
          width={24}
        />
        <Stack spacing={0.5} width={'100%'}>
          <Skeleton
            data-testid="promote-modal-loading-line"
            height={24}
            width={'100%'}
          />
        </Stack>
      </Stack>
      <Skeleton
        data-testid="promote-modal-loading-block"
        height={70}
        width={'100%'}
      />
    </DialogContent>
    <DialogActions>
      <Skeleton
        data-testid="promote-modal-loading-action-primary"
        height={40}
        width={80}
      />
      <Skeleton
        data-testid="promote-modal-loading-action-secondary"
        height={40}
        width={80}
      />
    </DialogActions>
  </div>
);
export default PromoteModalLoading;
